import axios from "../config/axios"

const API_BASE = "/shipments/returned"

export const shipmentReturnService = {
  // Get all returns
  getAllReturns: (page = null, perPage = null, filters = {}) => {
    const params = {
      ...(page && { page }),
      ...(perPage && { per_page: perPage }),
      ...filters,
    }
    return axios.get(API_BASE, { params })
  },

  // Get single return
  getReturn: (returnId) => {
    return axios.get(`${API_BASE}/${returnId}`)
  },

  // Create return request
  createReturn: (data) => {
    return axios.post(API_BASE, data)
  },

  // Update return
  updateReturn: (returnId, data) => {
    return axios.put(`${API_BASE}/${returnId}`, data)
  },

  // Delete return
  deleteReturn: (returnId) => {
    return axios.delete(`${API_BASE}/${returnId}`)
  },

  initiatePayment: (returnId) => {
    return axios.post(`${API_BASE}/${returnId}/initiate-payment`)
  },

  markPaymentRefunded: (returnId, formData) => {
    return axios.post(`${API_BASE}/${returnId}/mark-refunded`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
  },

  getPaymentReceipt: (returnId) => {
    return axios.get(`${API_BASE}/${returnId}/receipt`, {
      responseType: "blob",
    })
  },

  getPaymentReceiptBase64: (returnId) => {
    return axios.get(`${API_BASE}/${returnId}/receipt-base64`)
  },

  // Approve return
  approveReturn: (returnId) => {
    return axios.post(`${API_BASE}/${returnId}/approve`)
  },

  // Reject return
  rejectReturn: (returnId, rejectionReason) => {
    return axios.post(`${API_BASE}/${returnId}/reject`, {
      rejection_reason: rejectionReason,
    })
  },

  // Get payment receipt
  getPaymentReceipt: (returnId) => {
    return axios.get(`${API_BASE}/${returnId}/receipt`, {
      responseType: "blob",
    })
  },

  // Get pending returns
  getPendingReturns: (page = null, perPage = null) => {
    const params = {};
    if (page) params.page = page;
    if (perPage) params.per_page = perPage;
    return axios.get(`${API_BASE}/pending`, { params })
  },

  // Get return reasons
  getReturnReasons: async () => {
    return axios.get('${API_BASE}/return-reasons')
  },

  // Get returns by shipment
  getReturnsByShipment: (shipmentId) => {
    return axios.get(`${API_BASE}/shipment/${shipmentId}`)
  },

  // Get pending shipments for agent
  getPendingShipmentsForReturn: () => {
    return axios.get(`${API_BASE}/available-shipments`)
  },
}
